import { render, staticRenderFns } from "./TypeConfirmation.vue?vue&type=template&id=7d00e6bb"
import script from "./TypeConfirmation.vue?vue&type=script&lang=js"
export * from "./TypeConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports